import { render } from "./text-formatter.vue?vue&type=template&id=4e4bdbb1&ts=true"
import script from "./text-formatter.vue?vue&type=script&lang=ts"
export * from "./text-formatter.vue?vue&type=script&lang=ts"

import "./text-formatter.vue?vue&type=style&index=0&id=4e4bdbb1&lang=scss"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\2\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__